module.exports = __webpack_public_path__ + "img/concact.b4b30ac4.png";